import { Button } from "primereact/button";
import { TieredMenu } from "primereact/tieredmenu";
import { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const NomenclaturesLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const sideBarItems = useMemo(
    () => [
      {
        label: "Специалности",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/specialities");
        },
        className: pathname === "/nomenclatures/specialities" ? "p-focus" : "",
      },
      {
        label: "Такси по специалности",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/specialityFees");
        },
        className: pathname === "/nomenclatures/specialityFees" ? "p-focus" : "",
      },
      {
        label: "Студентски групи",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/groups");
        },
        className: pathname === "/nomenclatures/groups" ? "p-focus" : "",
      },
      {
        label: "Академични длъжности",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/academicPositions");
        },
        className: pathname === "/nomenclatures/academicPositions" ? "p-focus" : "",
      },
      {
        label: "Академични степени",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/academicRanks");
        },
        className: pathname === "/nomenclatures/academicRanks" ? "p-focus" : "",
      },
      {
        label: "Учебни години",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/academicYears");
        },
        className: pathname === "/nomenclatures/academicYears" ? "p-focus" : "",
      },
      {
        label: "Позиции на факултетни номера",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/fnPositions");
        },
        className: pathname === "/nomenclatures/fnPositions" ? "p-focus" : "",
      },
      {
        label: "Основания за прием",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/admissionReasons");
        },
        className: pathname === "/nomenclatures/admissionReasons" ? "p-focus" : "",
      },
      {
        label: "Статуси на банките",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/bankStatuses");
        },
        className: pathname === "/nomenclatures/bankStatuses" ? "p-focus" : "",
      },
      {
        label: "Сгради",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/buildings");
        },
        className: pathname === "/nomenclatures/buildings" ? "p-focus" : "",
      },
      {
        label: "Градове",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/cities");
        },
        className: pathname === "/nomenclatures/cities" ? "p-focus" : "",
      },
      {
        label: "Държави",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/countries");
        },
        className: pathname === "/nomenclatures/countries" ? "p-focus" : "",
      },
      {
        label: "ОКС",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/degrees");
        },
        className: pathname === "/nomenclatures/degrees" ? "p-focus" : "",
      },
      {
        label: "Факултети / филиали",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/faculties");
        },
        className: pathname === "/nomenclatures/faculties" ? "p-focus" : "",
      },
      {
        label: "Катедри",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/departments");
        },
        className: pathname === "/nomenclatures/departments" ? "p-focus" : "",
      },
      {
        label: "Типове семестриални такси",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/feeTypes");
        },
        className: pathname === "/nomenclatures/feeTypes" ? "p-focus" : "",
      },
      {
        label: "Типове идентификации",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/identificationTypes");
        },
        className: pathname === "/nomenclatures/identificationTypes" ? "p-focus" : "",
      },
      {
        label: "Типове магистърски степени",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/masterDegreeTypes");
        },
        className: pathname === "/nomenclatures/masterDegreeTypes" ? "p-focus" : "",
      },
      {
        label: "Общини",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/municipalities");
        },
        className: pathname === "/nomenclatures/municipalities" ? "p-focus" : "",
      },
      {
        label: "Типове планове",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/planTypes");
        },
        className: pathname === "/nomenclatures/planTypes" ? "p-focus" : "",
      },
      {
        label: "Квалификации",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/qualifications");
        },
        className: pathname === "/nomenclatures/qualifications" ? "p-focus" : "",
      },
      {
        label: "Региони",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/regions");
        },
        className: pathname === "/nomenclatures/regions" ? "p-focus" : "",
      },
      {
        label: "Профили на училищата",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/schoolProfiles");
        },
        className: pathname === "/nomenclatures/schoolProfiles" ? "p-focus" : "",
      },
      {
        label: "Училища",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/schools");
        },
        className: pathname === "/nomenclatures/schools" ? "p-focus" : "",
      },
      {
        label: "Типове семестри",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/semesterTypes");
        },
        className: pathname === "/nomenclatures/semesterTypes" ? "p-focus" : "",
      },
      {
        label: "Типове сесии",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/sessionTypes");
        },
        className: pathname === "/nomenclatures/sessionTypes" ? "p-focus" : "",
      },
      {
        label: "Форми на специалности",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/specialityForms");
        },
        className: pathname === "/nomenclatures/specialityForms" ? "p-focus" : "",
      },
      {
        label: "Форми на обучение",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/specialityModes");
        },
        className: pathname === "/nomenclatures/specialityModes" ? "p-focus" : "",
      },
      {
        label: "Типове финансиране",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/specialityTypes");
        },
        className: pathname === "/nomenclatures/specialityTypes" ? "p-focus" : "",
      },
      {
        label: "Статуси на студентите",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/studentStatuses");
        },
        className: pathname === "/nomenclatures/studentStatuses" ? "p-focus" : "",
      },
      {
        label: "Типове контрол по дисциплини",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/subjectControlTypes");
        },
        className: pathname === "/nomenclatures/subjectControlTypes" ? "p-focus" : "",
      },
      {
        label: "Дисциплини",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/subjects");
        },
        className: pathname === "/nomenclatures/subjects" ? "p-focus" : "",
      },
      {
        label: "Типове дисциплини",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/subjectTypes");
        },
        className: pathname === "/nomenclatures/subjectTypes" ? "p-focus" : "",
      },
      {
        label: "Статуси на преподавателите",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/teacherStatuses");
        },
        className: pathname === "/nomenclatures/teacherStatuses" ? "p-focus" : "",
      },
      {
        label: "Университети",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/universities");
        },
        className: pathname === "/nomenclatures/universities" ? "p-focus" : "",
      },
      {
        label: "Направления",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/universityFields");
        },
        className: pathname === "/nomenclatures/universityFields" ? "p-focus" : "",
      },
      {
        label: "Специалности на университети",
        icon: "pi pi-list",
        command: () => {
          navigate("/nomenclatures/universitySpecialities");
        },
        className: pathname === "/nomenclatures/universitySpecialities" ? "p-focus" : "",
      },
    ],

    [],
  );

  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);

  useEffect(() => {
    const storedPreference = localStorage.getItem('menuCollapsed');
    if (storedPreference !== null) {
      setIsMenuCollapsed(JSON.parse(storedPreference));
    }
  }, []);

  const toggleMenu = () => {
    const newState = !isMenuCollapsed;
    setIsMenuCollapsed(newState);
    localStorage.setItem('menuCollapsed', JSON.stringify(newState));
  };

  return (
    <div className="flex md:flex-row flex-column p-4">
      <div className={`flex flex-column ${isMenuCollapsed ? 'md:w-min' : 'md:w-2'} shadow-2 transition-all transition-duration-300`}>
        <Button 
          icon={`pi pi-angle-double-${isMenuCollapsed ? 'right' : 'left'}`}
          onClick={toggleMenu}
          className="mb-1"
          severity="secondary"
          text
          aria-label="Toggle menu"
        />
        <TieredMenu 
          model={sideBarItems} 
          breakpoint="767px" 
          className={`w-full ${isMenuCollapsed ? 'hidden' : ''}`} 
        />
      </div>
      <div className={`flex flex-column flex-grow-1 ${isMenuCollapsed ? 'md:w-11' : 'md:w-10'} mx-4 transition-all transition-duration-300`}>
        <Outlet />
      </div>
    </div>
  );
};

export default NomenclaturesLayout;
